import { schema } from 'normalizr';
import departmentSchema from './department_schema';
import entryTypeSchema from './entry_type_schema';

export default new schema.Entity('field_configurations', {
  departments: [departmentSchema],
  entry_type: entryTypeSchema,
});
